import { Component, ChangeDetectionStrategy, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { WindowService } from '@modules/shared/services/window.service';

@Component({
  selector: 'mb-ics-modal',
  templateUrl: './ics-modal.component.html',
  styleUrls: ['./ics-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IcsModalComponent implements OnInit {
  public isMobile = false;
  @Input() icsLink!: string;

  @Output() confirm = new EventEmitter<{ remember: boolean }>();
  @Output() cancel = new EventEmitter();

  constructor(private windowService: WindowService) {}

  ngOnInit() {
    this.isMobile = this.windowService.isMobileBrowser;
  }
}
